// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2JyiI","right":"styles_right__31PQ3"};